/* eslint-disable no-unreachable */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { FC } from "react";
import styles from "./index.module.css";
import { useNavigate, useParams } from "react-router-dom";
import { Header } from "../../components/Header";
import { Menu } from "../../components/Menu";
import PixImg from "../../assets/images/pix.png";
import { floatToCents } from "../../functions/price_functions";
import { useAppConfig } from "../../hooks/useAppConfig";
import { useEffect, useState } from "react";
import { Loading } from "../../components/Loading";
import { ConfigType } from "../../contexts/AppConfigContext";
import api from "../../services/api";
import { usePluginspace } from "../../hooks/usePluginspace";
import Swal from "sweetalert2";
import {
  CardType,
  CustomerType,
  OrderAddress,
  OrderIntegrationPlanType,
  OrderToSendType,
  OrderType,
} from "../../contexts/OrderContext";
import { cpfCnpjNoMask, rtcToText } from "../../functions/mask";
import { v4 as uuidv4 } from "uuid";
import { ModalTerms } from "../../components/ModalTerms";
import { CheckoutOrder } from "../../components/checkoutOrder/checkoutOrder";
import { SumaryOrder } from "../../components/sumaryOrder/sumaryOrder.module";
import { InfoPurchase } from "../../components/InfoPurchase/InfoPurchase";
import { InfoCustomer } from "../../components/InfoCustomer/InfoCustomer";
import { InfoAddressOrder } from "../../components/InfoAddressOrder/InfoAddressOrder";
import { InfoOrderItens } from "../../components/InfoOrderItens/InfoOrderItens";
import { ButtonCheckout } from "../../components/buttonCheckout/ButtonCheckout";
import { OrderObservation } from "../../components/OrderObservation/OrderObservation";
import { InfoSeller } from "../../components/InfoSeller/InfoSeller";
import { useDiscount } from "../../hooks/useDiscount";
import { useClearSale } from "../../contexts/ClearSaleContext";
import { useFaceBookPixel } from "../../hooks/useFacebookPixel";
import { useSellerInfo } from "../../contexts/sellerInfoContext";
import useCart, { useCartActions } from "../../contexts/cartContext/cartContext";
import { usePayment, usePaymentActions } from "../../contexts/paymentContext/paymentContext";
import { useOrderActions, useOrderMetaData, useOrderTotal } from "../../contexts/orderMetaDataContext/orderMetaDataContext";
import { useCustomer, useCustomerActions } from "../../contexts/customerContext/customerContext";
import { CheckoutCustomer, OrderCompleteMetadata } from "../../contexts/orderMetaDataContext/orderMetaData.type";

type PlansType = {
  id: number;
  codePlan: number;
  installment: number;
};

export type IntegrationType = {
  id: number;
  pluginconfigId: number;
  brand: string;
  cardOperator: number;
  codePay: string;
  nameGateway: string;
  paymentPlans: PlansType[];
  typePay: string;
};

type CardTotvsType = {
  amount: number;
  deliveryfee: number;
  installments: number | string;
  cardholderName: string;
  cardNumber: null;
  nameCardBrand: string;
  expirationMonth: string;
  expirationYear: string;
  securityCode: string;
  brand: string;
  tokenizedPan: string;
  fingerprintSessionId: string;
};

type SkuStockType = {
  sku: string;
  name: string;
  context: string;
  inventory: number;
  minimumStock: number;
};

const NewOrderFinalize: FC = () => {
  const navigate = useNavigate();
  const { pluginspace_id } = useParams();
  const {
    sessionId,
    initializeClearSale,
    loading: clearSaleLoading,
    getCurrentSessionId,
    generateNewSessionId,
    checkClearSaleStatus,
    forceClearSaleExecution,
    isConfigurationValid,
  } = useClearSale();
  const { getToken, registerAccess, getThisPluginspace, pluginspace } = usePluginspace();
  const { trackPurchase } = useFaceBookPixel();
  const cart = useCart();
  const { clearCart } = useCartActions();
  const customerContext = useCustomer();
  const { clearCustomer, clearCustomerAddress } = useCustomerActions();
  const paymentContext = usePayment();
  const { clearPaymentMethod, clearCard, clearInstallments } = usePaymentActions();
  const discountContext = useDiscount();
  const { clearAllDiscounts, finishDiscounts } = useDiscount();
  const { products } = useCart()

  const orderMetadata = useOrderMetaData();
  const { setNotes, clearMetadata, generateDataToSendOrderCard, setMetaDataComplete, } = useOrderActions();
  const orderTotal = useOrderTotal();

  const { sellerInfo } = useSellerInfo();
  const { getAppConfig } = useAppConfig();
  const { pluginspaceData } = usePluginspace();
  const [config, setConfig] = useState<ConfigType | void>();
  const [loading, setLoading] = useState(true);
  const [orderAddress, setOrderAddress] = useState<OrderAddress>();
  const [customer, setCustomer] = useState<CustomerType>();
  const [type, setType] = useState("");
  const [cpfInNote, setCpfInNote] = useState("");
  const [paymentType, setPaymentType] = useState("");
  const [order, setOrder] = useState<OrderType>();
  //Esse total, possui total do pedido, com desconto aplicado, caso exista algum desconto + Frete
  const [total, setTotal] = useState(0);
  const [freight, setFreight] = useState(0);
  const [card, setCard] = useState<CardType>();
  const [haveGuid, setHaveGuid] = useState(false);
  const [installment, setInstallment] = useState(0);
  const [installmentValue, setInstallmentValue] = useState(0);

  const [integrationPlanLocal, setIntegrationPlanLocal] = useState<OrderIntegrationPlanType>();

  const [methodPayment, setMethodPayment] = useState("");

  const [paymentMethod, setPaymentMethod] = useState<JSX.Element | undefined>();
  const [uuid, setUuid] = useState("");

  // Para o cliente vindo do link de pagamento
  const [useWpp, setUseWpp] = useState(false);
  const [openTerms, setOpenTerms] = useState(false);
  const [acceptTerm, setAcceptTerm] = useState(false);
  const [term, setTerm] = useState("");

  const [validShift, setValidShift] = useState(true);

  const [loadingHeader, setLoadingHeader] = useState(true);

  const [retirarServico, setRetirarServico] = useState(false);
  const [changePaymentValue, setChangePayment] = useState(0);

  const [cupomDiscount, setCupomDiscount] = useState("");
  const [cashbackRedeemAmount, setCashbackRedeemAmount] = useState(0);

  const [paymentDiscount, setPaymentDiscount] = useState<{ type: string; discountValue: string; } | null>();

  const observation = orderMetadata.metadata.notes ?? "";
  const handleSetObservation = (value: string) => setNotes(value);

  const getMappedOrderAddress = () => {
    const address = customerContext.customerAddress;
    if (!address) return undefined;

    const orderAddress: OrderAddress = {
      cep: address.cep,
      address: address.street,
      district: address.neighborhood,
      city: address.city,
      number: address.number,
      complement: address.complement ?? "",
      reference: address.reference ?? "",
      telephone: "",
      ibge: "",
      state: address.state,
      extra: address.complement ?? "",
    };

    return orderAddress;
  };

  const getMappedCustomer = () => {
    const customer = customerContext.customer;
    if (!customer) return undefined;

    const orderCustomer: CustomerType = {
      name: customer.name,
      id: parseInt(customer.id),
      email: customer.email,
      cpf: customer.cpf ?? "",
      telephone: customer.phone ?? "",
      cep: customerContext.customerAddress?.cep,
      address: customerContext.customerAddress?.street,
      number: customerContext.customerAddress?.number,
      complement: customerContext.customerAddress?.complement,
      district: customerContext.customerAddress?.neighborhood,
      city: customerContext.customerAddress?.city,
      state: customerContext.customerAddress?.state,
      ibge: "",
      acceptTermDate: new Date(),
    };

    return orderCustomer;
  };

  const getMappedCustomerToSend = (): CheckoutCustomer | null => {
    const customer = customerContext.customer;
    if (!customer) return null;

    const orderCustomer: CheckoutCustomer = {
      id: customer.id,
      name: customer.name,
      email: customer.email,
      phone: customer.phone,
      cpf: customer.cpf ?? undefined,
      birthdate: customer.birthdate ?? undefined,
    }
    return orderCustomer;
  }

  const getGatewayId = () =>
    paymentContext.paymentMethod?.paymentItemData?.pluginconfigId ?? 0;

  const getLocationId = () =>
    orderMetadata.metadata.locationId
      ? parseInt(orderMetadata.metadata.locationId)
      : 0;

  const getMappedCard = (): CardType | undefined => {
    if (!paymentContext.card) return undefined;

    const expiryDate = paymentContext.card.expiryDate || "";
    const [month = "", year = ""] = expiryDate.split(/[\/\-]/);

    return {
      name: paymentContext.card.holderName || "",
      number: paymentContext.card.number || "",
      month,
      year,
      installments:
        paymentContext.selectedInstallment?.number?.toString() ||
        paymentContext.paymentMethod?.installments?.toString() ||
        "1",
      brand:
        (paymentContext.paymentMethod?.nameBrand ||
          paymentContext.paymentMethod?.paymentItemData?.brand ||
          "") as string,
      cvv: paymentContext.card.cvv || "",
    };
  };

  const getIntegrationPlanFromPayment = (): OrderIntegrationPlanType | undefined => {
    const paymentMethod = paymentContext.paymentMethod;
    if (!paymentMethod) return undefined;

    return {
      codePay: paymentMethod.codePay,
      codePlan: paymentMethod.codePlan,
      nameGateway: paymentMethod.nameGateway,
      paymentItemData: paymentMethod.paymentItemData as any,
      nameBrand: paymentMethod.nameBrand,
      typePayment: paymentMethod.typePayment,
    };
  };

  const clearCheckoutState = () => {
    clearCart();
    clearCustomer();
    clearCustomerAddress();
    clearPaymentMethod();
    clearCard();
    clearInstallments();
    clearAllDiscounts();
    clearMetadata();
  };


  useEffect(() => {
    registerAccess("finalize-order");
    getConfig();
  }, []);

  // Separar a inicialização do ClearSale
  useEffect(() => {
    console.log(
      "[CS] useEffect NewOrderFinalize - Chamando initializeClearSale"
    );
    // Garantir que o ClearSale seja inicializado quando o componente carregar
    initializeClearSale();
  }, [initializeClearSale]);

  // Log para monitorar mudanças no sessionId
  useEffect(() => {
    console.log("[CS] NewOrderFinalize - sessionId mudou:", {
      sessionId: sessionId ? sessionId.substring(0, 10) + "..." : "null",
      loading: clearSaleLoading,
      timestamp: new Date().toISOString(),
    });
  }, [sessionId, clearSaleLoading]);

  // Função para aguardar o ClearSale estar pronto
  const waitForClearSaleReady = async (maxWaitTime = 10000) => {
    console.log("[CS] waitForClearSaleReady - Iniciando espera...");

    const startTime = Date.now();

    while (Date.now() - startTime < maxWaitTime) {
      // Re-obter o valor do contexto em cada iteração
      const currentSessionId = sessionId;
      const currentLoading = clearSaleLoading;

      console.log("[CS] waitForClearSaleReady - Estado atual:", {
        sessionId: !!currentSessionId,
        loading: currentLoading,
        hasValue: currentSessionId ? currentSessionId.length > 0 : false,
      });

      if (currentSessionId && !currentLoading && currentSessionId.length > 0) {
        console.log("[CS] waitForClearSaleReady - ClearSale pronto!");
        return true;
      }

      await new Promise((resolve) => setTimeout(resolve, 200));
    }

    console.warn("[CS] waitForClearSaleReady - Timeout aguardando ClearSale");
    return false;
  };

  function loadOrder() {
    const cpfInNoteStorage = customerContext.customer?.cpf ?? "";
    const paymentTypeStorage = paymentContext.paymentMethod?.typePayment ?? "";
    const paymentTypeMethod = paymentContext.paymentMethod?.method ?? "";
    const changePaymentValue = paymentContext.changePayment ?? 0;
    const orderAddressStorage = getMappedOrderAddress();
    const customerStorage = getMappedCustomer();
    const typeStorage = orderMetadata.metadata.orderType ?? "";
    const orderStorage: OrderType = {
      products: (cart.products as unknown as any[]) || [],
    };
    const totalValue = orderTotal;
    const freightStorage = orderMetadata.metadata.freightCost ?? cart.freightCost;
    const cardStorage = getMappedCard();
    const integrationPlanStorage = getIntegrationPlanFromPayment();
    const cupomDiscount = discountContext.discounts.find(d => d.type === 'coupon')?.code ?? "";
    const cashbackRedeemAmount = discountContext.discounts.find(d => d.type === 'cashback')?.value ?? 0;
    const installment = paymentContext.selectedInstallment?.number ?? paymentContext.paymentMethod?.installments ?? 0;
    const installmentValue = paymentContext.selectedInstallment?.value ?? totalValue ??  0;
    const paymentDisc = discountContext.discounts.find(d => d.type === 'payment') ?? null;


    const guidCart = Boolean(localStorage.getItem("guidCart"));

    setChangePayment(changePaymentValue);
    setPaymentDiscount(paymentDisc ? { type: paymentDisc.type, discountValue: paymentDisc.value.toString() } : null);
    setHaveGuid(guidCart);
    showPaymentMethod(paymentTypeStorage);
    setMethodPayment(paymentTypeMethod);
    setOrderAddress(orderAddressStorage);
    setCustomer(customerStorage);
    setType(typeStorage);
    setCpfInNote(cpfInNoteStorage);
    setPaymentType(paymentTypeStorage);
    setOrder(orderStorage);
    setTotal(totalValue);
    setFreight(freightStorage);
    setCard(cardStorage);
    setIntegrationPlanLocal(integrationPlanStorage);
    setUuid(uuidv4());
    setCupomDiscount(cupomDiscount);
    setCashbackRedeemAmount(cashbackRedeemAmount);
    setInstallment(installment);
    setInstallmentValue(installmentValue);
  }

  async function getConfig() {
    setLoading(true);
    await getVerifyShift();
    setLoadingHeader(true);
    setConfig(await getAppConfig());
    setLoadingHeader(false);
    await loadOrder();
    await getTerms();

    setLoading(false);
  }


  async function setTokenizedCard(response: any) {
    if (response.tokenizedPan) {
      setLoading(true);
      const cardTotvs: CardTotvsType = {
        amount: floatToCents(total),
        deliveryfee: floatToCents(freight),
        brand: response.brand,
        cardholderName: card?.name ? card?.name : "",
        cardNumber: null,
        expirationMonth: card?.month ? card?.month : "",
        expirationYear: card?.year ? card.year : "",
        installments: card?.installments ? card.installments : 1,
        nameCardBrand: response.brandName,
        securityCode: card?.cvv ? card.cvv : "",
        tokenizedPan: response.tokenizedPan,
        fingerprintSessionId: response.fingerprintSessionId,
      };

      const encryptedData = await generateGatewayCardTotvs(cardTotvs);
      const customerStorage = getMappedCustomerToSend();
      if (!customerStorage) {
        setLoading(false);
        Swal.fire({
          icon: "error",
          title: "Erro",
          text: "Não foi possível finalizar sua compra",
        });
        return;
      }
      const orderData: OrderToSendType | undefined =
        await generateDataToSendOrderCard(
          customerStorage,
          encryptedData,
          uuid,
          retirarServico
        );

      if (orderData) {
        const resultStock = await verifyStock(orderData);
        if (resultStock) {
          const shouldChangeOrderAddress = localStorage.getItem(
            "shouldChangeAddressFashion"
          );
          if (shouldChangeOrderAddress && Boolean(shouldChangeOrderAddress)) {
            orderData.orderAddress!.cep = "00000001";
          }

          const resultPayment = await makePayment(orderData);
          setLoading(false);
          if (resultPayment && resultPayment.success === true) {
            trackPurchase(orderData.totalAmountOrder);

            const orderDataComplete: OrderCompleteMetadata = {
              orderId: resultPayment.dados.orderId,
              orderIdExt: resultPayment.dados.orderidExt,
              receipt: resultPayment.dados.customerReceipt.customer_receipt
            }
            setMetaDataComplete(orderDataComplete);
            finishDiscounts();

            clearCheckoutState();

            if (pluginspace?.type !== "food") {
              navigate(`/${pluginspace_id}/new-success-order`);
            } else {
              navigate(`/${pluginspace_id}/success-order`);
            }
          } else {
            setLoading(false);
            Swal.fire({
              icon: "error",
              title: "Erro",
              text:
                resultPayment &&
                  resultPayment.message &&
                  typeof resultPayment.message === "string"
                  ? resultPayment.message
                  : "Não foi possível finalizar sua compra",
            });
          }
        }
      } else {
        setLoading(false);
        Swal.fire({
          icon: "error",
          title: "Não foi possível finalizar sua compra",
          text: "Erro na integração com a TOTVS",
        });
      }
    } else {
      setLoading(false);
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Não foi possível finalizar sua compra",
      });
    }
  }

  async function goToOrderInfo() {
    localStorage.removeItem("cupom");
    finishDiscounts();
    clearCheckoutState();
    if (pluginspace?.type !== "food") {
      navigate(`/${pluginspace_id}/new-success-order`);
    } else {
      navigate(`/${pluginspace_id}/success-order`);
    }
  }

  async function totvsEncrypt() {
    const gatewayIdStorage = await getGatewayId();
    if (gatewayIdStorage) {
      return await api
        .get(`/api/pluginconfig/${gatewayIdStorage}`, {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        })
        .then(async (response) => {
          const dataPlugin = response.data;
          const cardStorage = getMappedCard();
          if (
            cardStorage &&
            dataPlugin.data &&
            dataPlugin.data[0] &&
            dataPlugin.data[0].content
          ) {
            const configTotvs = dataPlugin.data[0].content;
            const tkData = await api.post(
              `/api/totvshub/accessTotvs`,
              {
                gatewayId: gatewayIdStorage,
                pluginspaceId: pluginspaceData?.id ? pluginspaceData?.id : 1,
              },
              {
                headers: {
                  Authorization: `Bearer ${await getToken()}`,
                },
              }
            );
            if (
              tkData.data &&
              tkData.data.success &&
              tkData.data.tokenData &&
              tkData.data.tokenData.access_token
            ) {
              // @ts-ignore
              clientData = {
                amount: floatToCents(total),
                currency: "BRL",
                cardType: "CreditCard",
                externalPosId: configTotvs.externalposid,
                externalBusinessUnitId: configTotvs.externalbusinessunitid,
                externalTransactionId: configTotvs.externaltransactionid,
                installments: parseInt(cardStorage.installments),
                card: {
                  expirationYear: cardStorage.year,
                  expirationMonth: cardStorage.month,
                  securityCode: cardStorage.cvv,
                  number: cardStorage.number,
                },
                getTokenInfoAPI: {
                  // 		uri: 'https://dev.raas.varejo.totvs.com.br/pay-hub/transacting/card/api/payment-data',
                  uri: configTotvs.urlGetPaymentData,
                  token: tkData.data.tokenData.access_token,
                },
              };
              // const access_token = "eyJhbGciOiJSUzI1NiIsImtpZCI6IjJiYjZmYzUyM2ZjNzQwZjI4NmMxOTZmY2ExMzUyNzE2IiwidHlwIjoiSldUIn0.eyJuYmYiOjE2NjkwMzIwMDYsImV4cCI6MTY2OTExODQwNiwiaXNzIjoiaHR0cHM6Ly90b3R2c3JhYXMucmFjLmRldi50b3R2cy5hcHAvdG90dnMucmFjIiwiYXVkIjoiYXV0aG9yaXphdGlvbl9hcGkiLCJjbGllbnRfaWQiOiJwYXltZW50aHViX2JkYjc1NDBhODgwNjQwNDQ5ODBiYzFhMmUyZGQxZDA3X3JvIiwic3ViIjoiMzQyODEiLCJhdXRoX3RpbWUiOjE2NjkwMzIwMDYsImlkcCI6ImxvY2FsIiwiaHR0cDovL3d3dy50bmYuY29tL2lkZW50aXR5L2NsYWltcy9wcm9kdWN0SWQiOiIzNyIsImh0dHA6Ly93d3cudG5mLmNvbS9pZGVudGl0eS9jbGFpbXMvcHJvZHVjdE5hbWUiOiJUb3R2cyBSYWFTIFBheW1lbnQgSHViIiwiaHR0cDovL3d3dy50bmYuY29tL2lkZW50aXR5L2NsYWltcy9yYWNWZXJzaW9uIjoiMS4yOC41NS4wIiwiaHR0cDovL3d3dy50bmYuY29tL2lkZW50aXR5L2NsYWltcy9wcm9kdWN0Um9sZSI6WyJSZWZ1bmRBY2Nlc3NvclVzZXIiLCJSYWFzQWRtaW4iLCJQYXltZW50QWRtaW4iLCJST0FjY2Vzc29yVXNlciIsIkFkbWluIiwiUmVwb3J0UmVhZGVyIl0sInJvbGUiOlsiUmFhcyBwYXltZW50IGNvbmZpZ3VyaW5nIiwiQ2FkYXN0cm8gZGUgUGVyZmlsIl0sImh0dHA6Ly93d3cudG5mLmNvbS9pZGVudGl0eS9jbGFpbXMvY3VzdG9tUm9sZSI6WyJSYWFzUGF5bWVudENvbmZpZ3VyaW5nIiwiQ2FkYXN0cm9EZVBlcmZpbCJdLCJodHRwOi8vd3d3LnRuZi5jb20vaWRlbnRpdHkvY2xhaW1zL3RlbmFudElkIjoiOTgxZGQ0ZTgtMzI0My00Mjc0LWE0MjUtMDcyMDMzYTlkOTcxIiwiaHR0cDovL3d3dy50bmYuY29tL2lkZW50aXR5L2NsYWltcy90ZW5hbnROYW1lIjoidG90dnNyYWFzIiwiaHR0cDovL3d3dy50bmYuY29tL2lkZW50aXR5L2NsYWltcy90ZW5hbnRGdWxsTmFtZSI6IlRvdHZzIFJhYVMiLCJodHRwOi8vd3d3LnRuZi5jb20vaWRlbnRpdHkvY2xhaW1zL3RlbmFudElkTGVnYWN5IjoiODEiLCJodHRwOi8vd3d3LnRuZi5jb20vaWRlbnRpdHkvY2xhaW1zL3VzZXJGdWxsbmFtZSI6IkFsZXNzYW5kbyBCb3JnZXMiLCJuYW1lIjpbImFsZXNzYW5kcm9BU0JAZ21haWwuY29tIiwiQWxlc3NhbmRvIEJvcmdlcyJdLCJlbWFpbCI6ImFsZXNzYW5kcm9hc2JAZ21haWwuY29tIiwiaWF0IjoxNjY5MDMyMDA2LCJzY29wZSI6WyJhdXRob3JizemF0aW9uX2FwaSJdLCJhbXIiOlsicHdkIl19.HzH9zIhQM4OVZ77MKJNuRlHHtp6n1FDFp7kfm6f2Md0f7DjQFBpobFFOM2oKnWp0gafhesDtvClJ7QjB_LnJy37XuYAAchiNk-IzhXC5UGs0nb7hMOfiPuzhm0FCqNgTtedZkI9jpFg4LCzShopLmBNqG3VHq0PDaaAoTBu8ojl9iHQrzaRSaoyDLVj562Hco83Bq8I6w5hFMRcQ99nVd16as2wkEcQqcBNYNUtsyS0gTllu66PGdpXpEwQu2obXHBjG1eKAYbU-I2gAbXqQy39-nk_lfEvnQgpeyzuwwRQhM6ue2JuyhP1bkrVfA9rCxFChlE8Ks_Gwrw3YRsVxbA"
              // // @ts-ignore
              // clientData = {
              // 	amount: "150",
              // 	currency: "BRL",
              // 	cardType: "CreditCard",
              // 	externalPosId: "carnaval",
              // 	externalBusinessUnitId: "491",
              // 	installments: 3,
              // 	card: {
              // 		expirationYear: '2022',
              // 		expirationMonth: '12',
              // 		securityCode: '838',
              // 		brand: '',
              // 		number: '4622943127013705',
              // 	},
              // 	getTokenInfoAPI: {
              // 		uri: 'https://dev.raas.varejo.totvs.com.br/pay-hub/transacting/card/api/payment-data',
              // 		token: access_token,
              // 	}
              // }

              // @ts-ignore
              getTokenizedCardPan(clientData, setTokenizedCard);
            } else {
              setLoading(false);
              Swal.fire({
                icon: "error",
                title: "Erro",
                text: "Não foi possível finalizar sua compra",
              });
              return null;
            }
          } else {
            setLoading(false);
            Swal.fire({
              icon: "error",
              title: "Erro",
              text: "Não foi possível finalizar sua compra",
            });
            return null;
          }
        })
        .catch((err) => {
          setLoading(false);
          Swal.fire({
            icon: "error",
            title: "Erro",
            text: "Não foi possível finalizar sua compra",
          });
          return null;
        });
    } else {
      setLoading(false);
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Não foi possível finalizar sua compra",
      });
      return null;
    }
  }

  async function pagseguroEncrypt() {
    return await api
      .get("/api/pagseguro/pagseguroPublicKey", {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then(async (response) => {
        const cardStorage = getMappedCard();
        if (!cardStorage) {
          return null;
        }
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const encryptedCard = PagSeguro.encryptCard({
          publicKey: response.data.publicKey,
          holder: cardStorage.name,
          number: cardStorage.number,
          expMonth: cardStorage.month,
          expYear: cardStorage.year,
          securityCode: cardStorage.cvv,
        });
        return encryptedCard;
      })
      .catch((err) => {
        console.log(err);
        return null;
      });
  }

  function showPaymentMethod(typeStorage: string) {
    switch (typeStorage) {
      case "esitef-card":
        setPaymentMethod(<></>);
        break;
      // case 'cielo-card':
      //     setPaymentMethod(
      //         <div className="option">
      //             <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      //                 <path d="M16.577 15.0686C15.8016 14.3925 15.0545 13.74 14.298 13.0828C15.3855 11.6738 15.8205 10.0993 15.5132 8.34991C15.272 6.9693 14.5912 5.83928 13.5226 4.92675C11.5037 3.20098 7.93396 3.02131 5.69755 5.58869C4.95523 4.93148 4.20819 4.28372 3.4375 3.6076C5.46114 1.39011 7.93396 0.293179 10.9032 0.661973C14.5723 1.11587 17.0309 3.20571 18.1704 6.6998C19.1538 9.72107 18.5202 12.5201 16.577 15.0686Z" fill="#204987"/>
      //                 <path d="M3.42308 3.59818C4.1985 4.2743 4.94554 4.92678 5.70204 5.58399C4.61457 6.99298 4.17958 8.56744 4.48691 10.3169C4.72805 11.6975 5.4089 12.8275 6.47746 13.74C8.49637 15.4658 12.0661 15.6455 14.3025 13.0781C15.0496 13.7306 15.7966 14.3783 16.5673 15.0544C14.5436 17.2719 12.0708 18.3689 9.10157 18.0001C5.42781 17.5462 2.96918 15.4611 1.8297 11.967C0.846251 8.94097 1.47982 6.14191 3.42308 3.59818Z" fill="#27ABE3"/>
      //             </svg>
      //             <p>Cielo</p>
      //         </div>
      //     );
      //     break;
      // case 'pagseguro-card':
      //     setPaymentMethod(
      //         <div className="option">
      //             <img src={PagseguroImg} alt="Pagseguro" />
      //             <p>Pagseguro</p>
      //         </div>
      //     )
      //     break;
      // case 'rede-card':
      //     setPaymentMethod(
      //         <div className="option">
      //             <img src={RedeCardImg} alt="RedeCard" />
      //             <p>Redecard</p>
      //         </div>
      //     );
      //     break;
      case "pix":
        setPaymentMethod(
          <div className="option">
            <img src={PixImg} alt="Pix" />
            <p>Pix</p>
          </div>
        );
        break;
      default:
        break;
    }
  }

  async function generateNameBrand(codePayCard: string) {
    try {
      const resPluginspace = await api.get("/api/pluginspace/this", {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      });
      if (
        resPluginspace.data.data &&
        resPluginspace.data.data[0] &&
        resPluginspace.data.data[0].hash
      ) {
        const resIntegration = await api.post(
          "api/orders/card-payment-get",
          {
            hash: resPluginspace.data.data[0].hash,
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        );
        const cardFind = resIntegration.data.data.data.find(
          (integration: IntegrationType) => integration.codePay === codePayCard
        );
        if (cardFind) {
          return cardFind.brand;
        } else {
          return "";
        }
      }
      return "";
    } catch (e) {
      console.log(e);
      return "";
    }
  }

  async function generateCodePayPlanDelivery() {
    try {
      const resPluginspace = await api.get("/api/pluginspace/this", {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      });
      if (
        resPluginspace.data.data &&
        resPluginspace.data.data[0] &&
        resPluginspace.data.data[0].hash
      ) {
        const resIntegration = await api.post(
          "api/orders/card-payment-get",
          {
            hash: resPluginspace.data.data[0].hash,
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        );
        const gatewayIdStorage = getGatewayId();
        const newBrandsIntegrations: IntegrationType[] =
          resIntegration.data.data.data.filter(
            (integration: IntegrationType) =>
              integration.pluginconfigId === gatewayIdStorage
          );
        const integrationPlan = {
          codePay: integrationPlanLocal?.codePay
            ? integrationPlanLocal.codePay
            : newBrandsIntegrations[0].codePay,
          codePlan: integrationPlanLocal?.codePlan
            ? integrationPlanLocal.codePlan
            : newBrandsIntegrations[0].paymentPlans[0].codePlan,
          nameGateway: integrationPlanLocal?.nameGateway
            ? integrationPlanLocal.nameGateway
            : newBrandsIntegrations[0].nameGateway,
          nameBrand: integrationPlanLocal?.nameBrand
            ? integrationPlanLocal.nameBrand
            : newBrandsIntegrations[0].brand,
          paymentItemData: newBrandsIntegrations[0],
          typePayment: integrationPlanLocal?.typePayment,
        };
        const myContext = paymentContext.paymentMethod
        // orderContext.setIntegrationPlan(integrationPlan);
        // setIntegrationPlanLocal(integrationPlan);
      }
      return "";
    } catch (e) {
      console.log(e);
      return "";
    }
  }

  async function generateGatewayDelivery() {
    await generateCodePayPlanDelivery();

    return await api
      .post(
        "/api/cryptography/encryptJson",
        {
          value: {
            amount: floatToCents(total),
            deliveryfee: floatToCents(freight),
            installments: 1,
            holderName: customer?.name ? customer?.name : "",
          },
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then((response) => {
        return response.data.data.encryptedData;
      })
      .catch((err) => {
        console.log(err);
        return null;
      });
  }

  async function generateQRCode() {
    try {
      setLoading(true);
      const locationId = getLocationId();

      const orderSend: any = {
        locationId: locationId,
        products: products.map((p) => ({
          productSku: p.sku,
          quantity: p.quantity,
        })),
      };
      const resultStock = await verifyStock(orderSend);
      if (resultStock) {
        const gatewayId = await getGatewayId();
        const gatewayResponse = await api.get(`api/pluginconfig/${gatewayId}`, {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        });
        
        const resPluginspace = await api.get("api/pluginspace/this", {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        });
        if (
          resPluginspace.data.data &&
          resPluginspace.data.data[0] &&
          resPluginspace.data.data[0].hash
        ) {
          const resIntegration = await api.post(
            "api/orders/card-payment-get",
            {
              hash: resPluginspace.data.data[0].hash,
            },
            {
              headers: {
                Authorization: `Bearer ${await getToken()}`,
              },
            }
          );
          const newBrandsIntegrations: IntegrationType[] =
            resIntegration.data.data.data.filter(
              (integration: IntegrationType) =>
                integration.pluginconfigId === gatewayId &&
                integration.brand === "Pix"
            );
          if (newBrandsIntegrations[0]) {
            const integrationPlan = {
              codePay: newBrandsIntegrations[0].codePay,
              codePlan: newBrandsIntegrations[0].paymentPlans[0].codePlan,
              nameGateway: newBrandsIntegrations[0].nameGateway,
              nameBrand: "pix",
              paymentItemData: newBrandsIntegrations[0],
              typePayment: "pix",
            };
            setIntegrationPlanLocal(integrationPlan as any);
            setLoading(false);
            navigate(`/${pluginspace_id}/new-order-qrcode`);
          } else {
            setLoading(false);
            Swal.fire({
              icon: "error",
              title: "Erro!",
              text: `Não foi possível achar meio de pagamento cadastrado`,
            });
            return;
          }
        }
        setLoading(false);
        navigate(`/${pluginspace_id}/order-qrcode`);
      }
    } catch (e) {
      setLoading(false);
      navigate(`/${pluginspace_id}/order-qrcode`);
      console.log(e);
    }
  }

  async function generateGatewayCardTotvs(cardTotvs: CardTotvsType) {
    return await api
      .post(
        "api/cryptography/encryptJson",
        {
          value: cardTotvs,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then((response) => {
        return response.data.data.encryptedData;
      })
      .catch((err) => {
        console.log(err);
        return null;
      });
  }

  async function generateGatewayCardGeral() {
    let nameCardBrand = "";
    const cardStorage = getMappedCard();
    if (!cardStorage) return null;

    nameCardBrand = await generateNameBrand(cardStorage.brand);
    return await api
      .post(
        "/api/cryptography/encryptJson",
        {
          value: {
            amount: floatToCents(total),
            cardBrand: cardStorage.brand.toString(),
            deliveryfee: floatToCents(freight),
            installments:
              cardStorage.installments !== undefined
                ? parseInt(cardStorage.installments)
                : cardStorage.installments,
            nameCardBrand: nameCardBrand
              ? nameCardBrand
              : cardStorage.brand.toString(),
            cardholderName: cardStorage.name,
            cardNumber: cardStorage.number,
            securityCode: cardStorage.cvv,
            expirationMonth:
              cardStorage.month !== undefined
                ? parseInt(cardStorage.month)
                : cardStorage.month,
            expirationYear:
              cardStorage.year !== undefined
                ? parseInt(cardStorage.year)
                : cardStorage.year,
          },
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then((response) => {
        return response.data.data.encryptedData;
      })
      .catch((err) => {
        console.log(err);
        return null;
      });
  }

  async function generateGatewayCardPagseguro(encryptedCard: string) {
    const cardStorage = getMappedCard();
    if (!cardStorage) return null;
    return await api
      .post(
        "/api/cryptography/encryptJson",
        {
          value: {
            amount: floatToCents(total),
            cardBrand: cardStorage.brand.includes("ECOMMERCE")
              ? "ECOMMERCE"
              : cardStorage.brand,
            deliveryfee: floatToCents(freight),
            installments: cardStorage.installments,
            nameCardBrand: cardStorage.brand.includes("ECOMMERCE")
              ? "ECOMMERCE"
              : cardStorage.brand,
            cardNumber: cardStorage.number,
            cardholderName: cardStorage.name,
            securityCode: cardStorage.cvv,
            expirationMonth: cardStorage.month,
            expirationYear: cardStorage.year,
            encryptedCard: encryptedCard,
          },
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then((response) => {
        return response.data.data.encryptedData;
      })
      .catch((err) => {
        console.log(err);
        return null;
      });
  }

  async function getVerifyShift() {
    try {
      const pgData = await getThisPluginspace();
      const response = await api.post(
        `api/location-operation/verify`,
        {},
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      );

      if (pgData && pgData.type === "food") {
        setValidShift(response.data && response.data.success);
      } else {
        setValidShift(true);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function finalizeOrder() {
    if (!validShift) {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: `A loja se encontra fechada e não está aceitando pedidos`,
      });
      return;
    }
    setLoading(true);

    if (haveGuid) await updateCustomer();
    if (!loading) setLoading(true);

    switch (methodPayment) {
      case "pagseguro-card":
        finalizeOrderPagseguro();
        break;
      case "rede-card":
        finalizeOrderGeralCard();
        break;
      case "cielo-card":
        finalizeOrderGeralCard();
        break;
      case "totvs-card":
        finalizeOrderTotvs();
        break;
      case "delivery-payment":
        finalizeOrderGeralDelivery();
        break;
    }
  }

  async function finalizeOrderTotvs() {
    setLoading(true);
    await totvsEncrypt();
    setTimeout(() => {
      if (loading) setLoading(false);
    }, 1000);
  }

  async function finalizeOrderPagseguro() {
    setLoading(true);
    const encryptedCard = await pagseguroEncrypt();
    const customerToSend = getMappedCustomerToSend();
    if (encryptedCard.errors.length === 0 && customerToSend !== null) {
      const encryptedData = await generateGatewayCardPagseguro(
        encryptedCard.encryptedCard
      );

      const orderData: OrderToSendType | undefined =
        await generateDataToSendOrderCard(
          customerToSend,
          encryptedData,
          uuid,
          retirarServico
        );
      if (orderData) {
        const resultStock = await verifyStock(orderData);
        if (resultStock) {
          const shouldChangeOrderAddress = localStorage.getItem(
            "shouldChangeAddressFashion"
          );
          if (shouldChangeOrderAddress && Boolean(shouldChangeOrderAddress)) {
            orderData.orderAddress!.cep = "00000001";
          }

          const resultPayment = await makePayment(orderData);
          setLoading(false);
          if (resultPayment && resultPayment.success === true) {
            trackPurchase(orderData.totalAmountOrder);
            const orderDataComplete: OrderCompleteMetadata = {
              orderId: resultPayment.dados.orderId,
              orderIdExt: resultPayment.dados.orderidExt,
              receipt: resultPayment.dados.customerReceipt.customer_receipt
            }
            setMetaDataComplete(orderDataComplete);

            await goToOrderInfo();
          } else {
            Swal.fire({
              icon: "error",
              title: "Erro",
              text:
                resultPayment &&
                  resultPayment.message &&
                  typeof resultPayment.message === "string"
                  ? resultPayment.message
                  : "Não foi possível finalizar sua compra",
            });
          }
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Erro",
          text: "Não foi possível finalizar sua compra",
        });
      }
    } else {
      setLoading(false);
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Não foi possível finalizar sua compra",
      });
    }
  }

  async function finalizeOrderGeralDelivery() {
    setLoading(true);
    const customerToSend = getMappedCustomerToSend();
    if (customerToSend !== null) {
      const encryptedData = await generateGatewayDelivery();
      const orderData: OrderToSendType | undefined =
        await generateDataToSendOrderCard(
          customerToSend,
          encryptedData,
          uuid,
          retirarServico,
          false,
          true
        );
      if (orderData) {
        const resultStock = await verifyStock(orderData);
        if (resultStock) {
          const shouldChangeOrderAddress = localStorage.getItem(
            "shouldChangeAddressFashion"
          );
          if (shouldChangeOrderAddress && Boolean(shouldChangeOrderAddress)) {
            orderData.orderAddress!.cep = "00000001";
          }

          const resultPayment = await makePayment(orderData);
          setLoading(false);
          if (resultPayment && resultPayment.success === true) {
            trackPurchase(orderData.totalAmountOrder);
            if (resultPayment.tablePayment) {
              Swal.fire({
                icon: "success",
                title: "Sucesso!",
                text: "Pedido efetuado com sucesso.",
              }).then(async () => {
                if (
                  config &&
                  (config.template === "retail" || config.template === "food")
                ) {
                  if (config.content.pdv.showLayout === "l2") {
                    navigate(`/${pluginspace_id}/products-new`);
                  } else {
                    navigate(`/${pluginspace_id}/products`);
                  }
                } else {
                  navigate(`/${pluginspace_id}/category`);
                }
              });
            } else {
              const orderDataComplete: OrderCompleteMetadata = {
                orderId: resultPayment.dados.orderId,
                orderIdExt: resultPayment.dados.orderidExt,
                receipt: resultPayment.dados.customerReceipt.customer_receipt
              }
              setMetaDataComplete(orderDataComplete);
              goToOrderInfo();
            }
          } else {
            Swal.fire({
              icon: "error",
              title: "Erro",
              text:
                resultPayment &&
                  resultPayment.message &&
                  typeof resultPayment.message === "string"
                  ? resultPayment.message
                  : "Não foi possível finalizar sua compra",
            });
          }
        }
      } else {
        setLoading(false);
        Swal.fire({
          icon: "error",
          title: "Erro",
          text: "Não foi possível finalizar sua compra",
        });
      }
    } else {
      setLoading(false);
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Não foi possível finalizar sua compra",
      });
    }
  }

  async function finalizeOrderGeralCard() {
    setLoading(true);
    const customerToSend = getMappedCustomerToSend();

    if (customerToSend) {
      const encryptedData = await generateGatewayCardGeral();
      const orderData: OrderToSendType | undefined =
        await generateDataToSendOrderCard(
          customerToSend,
          encryptedData,
          uuid,
          retirarServico
        );
      if (orderData) {
        const resultStock = await verifyStock(orderData);
        if (resultStock) {
          const shouldChangeOrderAddress = localStorage.getItem(
            "shouldChangeAddressFashion"
          );
          if (shouldChangeOrderAddress && Boolean(shouldChangeOrderAddress)) {
            orderData.orderAddress!.cep = "00000001";
          }

          const resultPayment = await makePayment(orderData);
          setLoading(false);
          if (resultPayment && resultPayment.success === true) {
            trackPurchase(orderData.totalAmountOrder);
            const orderDataComplete: OrderCompleteMetadata = {
              orderId: resultPayment.dados.orderId,
              orderIdExt: resultPayment.dados.orderidExt,
              receipt: resultPayment.dados.customerReceipt.customer_receipt
            }
            setMetaDataComplete(orderDataComplete);

            await goToOrderInfo();
          } else {
            if (!resultPayment.success && resultPayment.typemsg === "info") {
              Swal.fire({
                icon: "info",
                title: "Aviso",
                text:
                  resultPayment &&
                    resultPayment.message &&
                    typeof resultPayment.message === "string"
                    ? resultPayment.message
                    : "Seu pedido está sendo processado e encontra-se em análise",
              }).then(async () => {
                //Caso mude o fluxo, retirar isso.

                const orderDataComplete: OrderCompleteMetadata = {
                  orderId: resultPayment.dados.orderId,
                  orderIdExt: resultPayment.dados.orderidExt,
                  receipt: resultPayment.dados.customerReceipt.customer_receipt
                }
                setMetaDataComplete(orderDataComplete);

                await goToOrderInfo();
              });
            } else {
              Swal.fire({
                icon: "error",
                title: "Erro",
                text:
                  resultPayment &&
                    resultPayment.message &&
                    typeof resultPayment.message === "string"
                    ? resultPayment.message
                    : "Não foi possível finalizar sua compra",
              });
            }
          }
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Erro",
          text: "Não foi possível finalizar sua compra",
        });
      }
    } else {
      setLoading(false);
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Não foi possível finalizar sua compra",
      });
    }
  }

  async function makePayment(orderData: OrderToSendType) {
    const orderSend = orderData;
    let landmark = await getLandmark();
    if (landmark) {
      orderSend.landmarkSynkar = landmark;
    }
    let landmarkPluginbot = await getLandmarkPluginbot();
    if (landmarkPluginbot) {
      orderSend.landmarkPluginbot = landmarkPluginbot;
    }

    //console.log('[CS] ===== INICIANDO PROCESSO DE PAGAMENTO =====');
    //console.log('[CS] Timestamp:', new Date().toISOString());

    // Verificar se ClearSale está configurado
    const clearSaleEnabled = isConfigurationValid();
    //console.log('[CS] ClearSale habilitado:', clearSaleEnabled);

    if (clearSaleEnabled) {
      // TENTATIVA DE GERAR NOVO SESSIONID PARA CLEARSALE
      try {
        console.log("[CS] Gerando NOVO sessionId para o pedido...");

        // Verificar status antes de gerar novo sessionId
        const statusBefore = checkClearSaleStatus();
        //console.log('[CS] Status ANTES da geração:', statusBefore);

        const newSessionId = await generateNewSessionId();

        if (newSessionId) {
          orderSend.sessionId = newSessionId;
          console.log(
            "[CS] Novo sessionId configurado no pedido:",
            newSessionId.substring(0, 5) + "..."
          );

          // Verificar status após geração
          const statusAfter = checkClearSaleStatus();
          //console.log('[CS] Status APÓS a geração:', statusAfter);

          // Forçar execução adicional se necessário
          if (statusAfter.queueLength === 0) {
            //console.log('[CS] Fila vazia, forçando execução adicional...');
            forceClearSaleExecution(newSessionId);
          }

          // Aguardar um pouco mais para garantir que o fingerprinting seja executado
          //console.log('[CS] Aguardando execução completa do fingerprinting...');
          await new Promise((resolve) => setTimeout(resolve, 2000));

          // Verificar status final
          const statusFinal = checkClearSaleStatus();
          //console.log('[CS] Status FINAL antes do envio:', statusFinal);
        } else {
          //console.warn('[CS] Não foi possível gerar novo sessionId, tentando fallback...');

          // Tentar usar sessionId existente como fallback
          const currentSessionId = await getCurrentSessionId();
          if (currentSessionId) {
            orderSend.sessionId = currentSessionId;
            //console.log('[CS] Usando sessionId existente como fallback:', currentSessionId.substring(0, 5) + '...');

            // Forçar execução com sessionId existente
            forceClearSaleExecution(currentSessionId);
            await new Promise((resolve) => setTimeout(resolve, 1000));
          } else {
            console.warn(
              "[CS] Nenhum sessionId disponível, prosseguindo sem ClearSale"
            );
          }
        }
      } catch (error) {
        console.error("[CS] Erro ao configurar ClearSale:", error);

        // Tentar fallback uma última vez
        try {
          const fallbackSessionId = await getCurrentSessionId();
          if (fallbackSessionId) {
            orderSend.sessionId = fallbackSessionId;
            console.log(
              "[CS] Fallback de emergência - usando sessionId existente:",
              fallbackSessionId.substring(0, 5) + "..."
            );
          }
        } catch (fallbackError) {
          console.warn(
            "[CS] Fallback também falhou, continuando sem ClearSale:",
            fallbackError
          );
        }
      }
    } else {
      console.log("[CS] ClearSale desabilitado, prosseguindo sem sessionId");
    }

    // Configurar URL de notificação
    orderSend.urlNotification = window.location.href.replace(
      "new-order-finalize",
      "new-success-order"
    );

    console.log("[CS] ===== ENVIANDO PEDIDO =====");
    console.log(
      "[CS] SessionId no pedido:",
      orderSend.sessionId
        ? orderSend.sessionId.substring(0, 10) + "..."
        : "null"
    );
    console.log("[CS] ClearSale ativo:", !!orderSend.sessionId);
    console.log("[CS] ============================");

    // Attempt to attach only the minimal hotelContext (customer.doc, id, room.id)
    const pickHotelFields = (ctx: any) => {
      if (!ctx || typeof ctx !== "object") return undefined;
      const out: any = {};
      if (ctx.id) out.id = ctx.id;
      if (ctx.customer && ctx.customer.doc)
        out.customer = { doc: ctx.customer.doc };
      // support alternate flat fields if present
      if (!out.customer && (ctx.customer_doc || ctx.customerDoc)) {
        out.customer = { doc: ctx.customer_doc || ctx.customerDoc };
      }
      if (ctx.room && ctx.room.id) out.room = { id: ctx.room.id };
      if (!out.room && (ctx.roomId || ctx.room_id)) {
        out.room = { id: ctx.roomId || ctx.room_id };
      }
      return Object.keys(out).length > 0 ? out : undefined;
    };

    // Use sessionStorage only (server endpoint removed per new decision)
    try {
      const stored = sessionStorage.getItem("hotelReservationContext");
      if (stored) {
        const parsed = JSON.parse(stored);
        const raw = Array.isArray(parsed) ? parsed[0] : parsed;

        // Verificar se é contexto view-only (não deve ser enviado ao backend)
        if (raw.viewOnly === true) {
          console.log(
            "Hotel context is view-only, skipping backend submission"
          );
        } else {
          // normalize stored shape { reservationId, doc, roomId }
          const normalized: any = {};
          if (raw.reservationId) normalized.id = raw.reservationId;
          if (raw.id) normalized.id = normalized.id || raw.id;
          if (raw.pluginspaceId) normalized.pluginspaceId = raw.pluginspaceId;
          const doc =
            raw.doc ||
            raw.customer?.doc ||
            raw.customer_doc ||
            raw.customerDoc ||
            raw.cpf;
          if (doc) normalized.customer = { doc };
          const roomId = raw.roomId || raw.room?.id || raw.room_id;
          if (roomId) normalized.room = { id: roomId };
          // create flat shape { id, doc, roomId }
          const flat: any = {};
          if (normalized.id) flat.id = normalized.id;
          if (normalized.customer && normalized.customer.doc)
            flat.doc = normalized.customer.doc;
          if (normalized.room && normalized.room.id)
            flat.roomId = normalized.room.id;

          // attach pluginspaceId if present in stored raw context
          const pluginspaceId =
            raw.pluginspaceId ||
            raw.pluginspace_id ||
            raw.pluginspace ||
            raw.father;
          if (pluginspaceId) flat.pluginspaceId = pluginspaceId;

          if (Object.keys(flat).length > 0) orderSend.hotelContext = flat;
        }
      }
    } catch (e) {
      console.warn(
        "Could not parse hotelReservationContext from sessionStorage",
        e
      );
    }

    // ENVIAR O PEDIDO (SEMPRE, INDEPENDENTE DO CLEARSALE)
    return await api
      .post("/api/orders/sendOrder", orderSend, {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then((response) => {
        if (response.data && response.data.success === true) {
          console.log("[CS] PEDIDO ENVIADO COM SUCESSO!");
          console.log("[CS] Timestamp:", new Date().toISOString());

          // Limpar localStorage após sucesso (apenas se usar ClearSale)
          if (orderSend.sessionId) {
            const storageKey = `cs_encryptedData_${pluginspaceData?.id || ""}`;
            localStorage.removeItem(storageKey);
            console.log(
              "[CS] localStorage limpo após erro para nova tentativa"
            );
          }

          return response.data;
        } else {
          console.warn(
            "[CS] Resposta do pedido não indica sucesso:",
            response.data
          );
          return response.data;
        }
      })
      .catch((err) => {
        //console.error('[CS] ERRO AO ENVIAR PEDIDO:', err);

        // Limpar localStorage em caso de erro também
        //if (orderSend.sessionId) {
        const storageKey = `cs_encryptedData_${pluginspaceData?.id || ""}`;
        localStorage.removeItem(storageKey);
        console.log("[CS] localStorage limpo após nova tentativa");
        //}

        return err.response ? err.response.data : null;
      });
  }

  async function verifyStock(orderData: OrderToSendType) {
    const pgData = await getThisPluginspace();
    if (config && !config.content.pdv.showOutStock) {
      return await api
        .post(
          `/api/variations/sku-inventory?order=ASC&page=${1}&take=${5000}`,
          {
            skus: orderData.products.map((product) => product.productSku),
            locationId: orderData.locationId,
            status: true,
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        )
        .then((response) => {
          const items = response.data;
          if (items.data) {
            let productsEmpty: SkuStockType[] = [];
            items.data.forEach((item: SkuStockType) => {
              const prod = orderData.products.find(
                (product) => product.productSku === item.sku
              );
              if (
                prod?.quantity &&
                item.inventory - item.minimumStock < prod.quantity
              ) {
                productsEmpty.push(item);
              }
            });
            if (productsEmpty && productsEmpty.length > 0) {
              setLoading(false);
              let textSwal = "";
              productsEmpty.forEach((product: SkuStockType) => {
                textSwal += `Produto: ${product.name} sem estoque<br/>`;
              });
              Swal.fire({
                icon: "warning",
                html: textSwal,
              });
              return false;
            }
            return true;
          } else {
            setLoading(false);
            Swal.fire({
              icon: "error",
              title: "Erro",
              text: "Não foi possível obter estoque dos produtos",
            });
          }
        })
        .catch((err) => {
          setLoading(false);
          Swal.fire({
            icon: "error",
            title: "Erro",
            text: "Não foi possível obter estoque dos produtos",
          });
        });
    } else {
      return true;
    }
  }

  async function getTermsTotvs() {
    return await api
      .get(`/api/letter-consent`, {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then(async (response) => {
        const totvsRes = response.data;
        if (totvsRes && totvsRes.data && totvsRes.data.body) {
          setTerm(rtcToText(totvsRes.data.body));
          return true;
        } else {
          return false;
        }
      })
      .catch((err) => {
        return false;
      });
  }

  async function getTerms() {
    const hasTotvsTerms = await getTermsTotvs();
    if (!hasTotvsTerms) {
      await api
        .post(
          `/api/consent/filter`,
          {
            active: true,
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        )
        .then(async (response) => {
          setTerm(response.data.data[0].content);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  function readTerms() {
    setOpenTerms(true);
  }

  // update de cliente com webApp e consentimento
  async function updateCustomer() {
    let customerBack: any = {};
    await api
      .post(
        `/api/customer/filter`,
        {
          cpf: customer!.cpf,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then(async (response) => {
        if (response.data.data.length > 0) {
          customerBack = response.data.data[0];
        }
      })
      .catch((err) => {
        console.log(err);
      });

    const customerToSend = {
      name: customer!.name,
      email: customer!.email,
      doc: cpfCnpjNoMask(customer!.cpf),
      cpf: cpfCnpjNoMask(customer!.cpf),
      optinWhatsapp: useWpp ? true : false,
      lgpdDataAceiteCarta: new Date(),
      addresses: [
        {
          zipCode: customerBack.customerAddresses[0].zipCode,
          street: customerBack.customerAddresses[0].address,
          number: customerBack.customerAddresses[0].number,
          district: customerBack.customerAddresses[0].district,
          city: customerBack.customerAddresses[0].city,
          state: customerBack.customerAddresses[0].state,
          extra: customerBack.customerAddresses[0].complement,
          reference: "",
          typeAddress: "main",
          ibge: customerBack.customerAddresses[0].ibge,
        },
      ],
    };

    await api
      .post(`/api/customer`, customerToSend, {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then((response) => {
        if (response.data.success === true) {
          return true;
        }
        // } else {
        // 	setLoading(false);
        // 	Swal.fire({
        // 		icon: "error",
        // 		title: "Erro!",
        // 		text: "Um erro ocorreu, tente novamente",
        // 	});
        // }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const getLandmark = () => {
    const landmark = localStorage.getItem("landmark_synkar");
    if (landmark) {
      const landmarkItem = JSON.parse(window.atob(landmark));
      return landmarkItem.interval;
    } else {
      return null;
    }
  };

  const getLandmarkPluginbot = () => {
    const landmark = localStorage.getItem("landmark_pluginbot");
    if (landmark) {
      const landmarkItem = JSON.parse(window.atob(landmark))
      return landmarkItem.interval
    } else {
      return null
    }
  }

  async function toFinishOrder() {
    try {
      if (methodPayment) {
        if (
          methodPayment.includes("pix") ||
          methodPayment.includes("wallet") ||
          methodPayment.includes("shipay")
        ) {
          generateQRCode();
        } else {
          finalizeOrder();
        }
      }
    } catch (error) {
      console.log("erro");
    }
  }

  return (
    <div className={styles.finalize_order}>
      <div className={styles.content_finalize_order}>
        {!loadingHeader && (
          <Header
            background={
              config?.webappcolor.backgroundheader
                ? config?.webappcolor.backgroundheader
                : "#F5F5F5"
            }
            colorIcon={
              config?.webappcolor.iconsheader
                ? config.webappcolor.iconsheader
                : "#636363"
            }
            logo={config?.icon ? config.icon : ""}
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
                config?.content &&
                config?.content.pdv &&
                config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
          />
        )}
        {loading ? (
          <div style={{ width: "100%", height: "calc(100vh)" }}>
            <Loading
              type="spinningBubbles"
              color="#FFF"
              width={64}
              height={64}
            />
          </div>
        ) : (
          <div className={styles.finalize_order_body}>
            <CheckoutOrder position={4} name={"Resumo"} />
            <SumaryOrder page="finalizado" />
            <InfoPurchase
              cpfInNote={cpfInNote}
              paymentType={paymentType}
              paymentMethod={paymentMethod}
              card={card}
              total={total}
              freight={freight}
              changePaymentValue={changePaymentValue}
              integrationPlanLocal={integrationPlanLocal}
              cupomDiscount={cupomDiscount}
              cashbackRedeemAmount={cashbackRedeemAmount}
              paymentDiscount={paymentDiscount}
              installment={installment}
              installmentValue={installmentValue}
              type={type}
            />
            {orderAddress && (
              <InfoAddressOrder
                orderAddress={orderAddress}
                type={type}
                freight={freight}
                config={config}
              />
            )}
            <InfoCustomer />

            <InfoOrderItens order={order} config={config} />
            {sellerInfo.id > 0 && <InfoSeller sellerInfo={sellerInfo} />}
            {config?.content.pdv.showObservation && (
              <OrderObservation
                observation={observation}
                setObservation={handleSetObservation}
                limitCharacters={config?.content?.pdv?.limitCharacters}
              />
            )}
          </div>
        )}
        {!loading && (
          <ButtonCheckout
            action={() => toFinishOrder()}
            label={"Continuar"}
            backgroundColor={
              config?.webappcolor.webappbutton
                ? config.webappcolor.webappbutton
                : "#EAEAEA"
            }
            color={
              config?.webappcolor.fontbutton
                ? config?.webappcolor.fontbutton
                : "#636363"
            }
            marginBottom
          />
        )}

        {!loadingHeader && (
          <Menu
            activeMenu="cart"
            fontColor={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            activeFontColor={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#000"
            }
            backgroundMenu={
              config?.webappcolor.backgroundfooter
                ? config?.webappcolor.backgroundfooter
                : "#F5F5F5"
            }
            colorIcons={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            highlightColorIcons={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#636363"
            }
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
                config?.content &&
                config?.content.pdv &&
                config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
          />
        )}
        {openTerms && (
          <ModalTerms
            isOpen={openTerms}
            setIsOpen={setOpenTerms}
            termContent={term}
            backgroundButton={
              config?.webappcolor.webappbutton &&
              config.webappcolor.webappbutton
            }
            fontButton={
              config?.webappcolor.fontbutton && config.webappcolor.fontbutton
            }
            acceptTerm={acceptTerm}
            setAcceptTerm={setAcceptTerm}
          />
        )}
      </div>
    </div>
  );
};

export { NewOrderFinalize };
